import React from "react";

const AgreementUploads = () => {
  return <div>AgreementUploads</div>;
};

export default AgreementUploads;
